<template>
  <div class="goodsbox-bd">
    <ul>
      <slot></slot>
    </ul>
    <slot name="bottom"></slot>
  </div>
</template>
<script>
export default {
  name: 'tGoodsbox',
  props: {

  },
};

</script>
<style lang="scss">
.goodsbox-bd {
  ul {
    display: flex;
    flex-wrap: wrap;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/custom/goodsbox.vue